export default function HubHeader() {
  const hubheaderBg = document.querySelector(".hub-header-bg");

  if (!hubheaderBg) return;

  const backgroundUrl = hubheaderBg.dataset.background;
  hubheaderBg.style.setProperty('background-image', `url(${backgroundUrl})`);

  // The image's focal point, so the band crops around what the member chose rather than the middle.
  if (hubheaderBg.dataset.backgroundPosition) {
    hubheaderBg.style.setProperty('background-position', hubheaderBg.dataset.backgroundPosition);
  }
}